import { Toaster as Sonner } from 'sonner';

import type { ComponentProps, FC } from 'react';

import { cn } from '@/lib/utils';

type ToasterProps = ComponentProps<typeof Sonner>;

const Toaster: FC<ToasterProps> = ({ ...props }) => {
  return (
    <Sonner
      className="toaster group"
      toastOptions={{
        classNames: {
          toast: cn(
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border',
            'min-w-[100dvw] max-[600px]:-left-4! [&[data-sonner-toast][data-x-position=right]]:-right-6! justify-center rounded-none! max-h-12 mb-7 shadow-none!',
            '[touch-action:none] [pointer-events:auto]'
          ),
          description: 'group-[.toast]:text-muted-foreground',
          actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
        },
      }}
      {...props}
    />
  );
};

export default Toaster;
